module.exports = __webpack_public_path__ + "static/media/session-info-chatvid.c167e934.mp4";